// src/api/referralsApi.ts

import { baseApi } from './baseApi';
import type {
  Referral,
  CreateReferralRequest,
  UpdateReferralRequest,
  ReferralDirection,
  ReferralStatus,
} from '../types/api';

export const referralsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReferrals: builder.query<
      Referral[],
      {
        workspaceId?: string;
        direction?: ReferralDirection;
        status?: ReferralStatus;
        contactId?: string;
        circleId?: string;
        search?: string;
      }
    >({
      query: ({ workspaceId, direction, status, contactId, circleId, search }) => {
        const params = new URLSearchParams();
        if (workspaceId) params.append('workspaceId', workspaceId);
        if (direction) params.append('direction', direction);
        if (status) params.append('status', status);
        if (contactId) params.append('contactId', contactId);
        if (circleId) params.append('circleId', circleId);
        if (search) params.append('search', search);
        return `/referrals?${params.toString()}`;
      },
      providesTags: ['Referral'],
    }),

    getReferral: builder.query<Referral, string>({
      query: (id) => `/referrals/${id}`,
      providesTags: ['Referral'],
    }),

    createReferral: builder.mutation<Referral, CreateReferralRequest>({
      query: (body) => ({
        url: '/referrals',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Referral'],
    }),

    updateReferral: builder.mutation<Referral, { id: string; data: UpdateReferralRequest }>({
      query: ({ id, data }) => ({
        url: `/referrals/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Referral'],
    }),

    deleteReferral: builder.mutation<{ success: boolean }, string>({
      query: (id) => ({
        url: `/referrals/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Referral'],
    }),
  }),
});

export const {
  useGetReferralsQuery,
  useGetReferralQuery,
  useCreateReferralMutation,
  useUpdateReferralMutation,
  useDeleteReferralMutation,
} = referralsApi;
